module.exports = __webpack_public_path__ + "media/images/flags/lb-8cb787e4829b3a81bb7e5ac087190b16.svg";